'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo, useState } from 'react';
const ModalContext = createContext(undefined);
export const ModalProvider = ({ children }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const value = useMemo(() => ({
        isModalOpen,
        openModal: () => setIsModalOpen(true),
        closeModal: () => setIsModalOpen(false),
        toggleModal: () => setIsModalOpen((prev) => !prev),
    }), [isModalOpen]);
    return _jsx(ModalContext.Provider, { value: value, children: children });
};
// Custom hook
export const useModal = () => {
    const context = useContext(ModalContext);
    if (!context) {
        throw new Error('useModal must be used inside ModalProvider');
    }
    return context;
};
